<template>
  <div data-slot="inline-social-content" class="flex min-w-0 items-center gap-3">
    <template v-if="isSkeleton">
      <ui-skeleton class="size-15.5 shrink-0 rounded-lg" />
      <div class="flex flex-1 flex-col gap-1.5">
        <ui-skeleton class="h-3.5 w-full" />
        <ui-skeleton class="h-3.5 w-11/12" />
      </div>
    </template>
    <template v-else>
      <lazy-image class="size-15.5 min-w-15.5 rounded-lg shadow-sm" :src="imageUrl" />
      <div class="flex min-w-0 flex-col items-start gap-1">
        <p class="m-0 line-clamp-2 text-sm text-foreground [overflow-wrap:anywhere]">{{ computedText }}</p>
        <ui-badge v-if="badge" variant="outline" class="font-normal text-muted-foreground">{{ badge }}</ui-badge>
      </div>
    </template>
  </div>
</template>

<script>
import Ad from '@/entities/Ad.js';
import AdCopyMagicItem from '@/entities/AdCopyMagicItem.js';
import ContentGenerationItem from '@/entities/ContentGenerationItem.js';
import Post from '@/entities/Post.js';
import LazyImage from '@/ui/components/LazyImage.vue';

/** Thumbnail + two lines of text of a post, ad or generated content. */
export default {
  name: 'InlineSocialContent',
  components: {
    LazyImage,
  },
  props: {
    entity: {
      type: [ Ad, Post ],
      required: false,
      default: () => null,
    },
    text: {
      type: String,
      required: false,
      default: () => '',
    },
    badge: {
      type: String,
      required: false,
      default: () => null,
    },
  },
  computed: {
    isSkeleton() {
      if (this.entity === null) {
        return true;
      }

      if (this.entity instanceof ContentGenerationItem) {
        return this.entity.isWaiting || this.entity.isInProgress;
      }

      return false;
    },
    imageUrl() {
      if (this.entity instanceof Ad && this.entity.post) {
        return this.entity.post.image_url;
      }
      else if (this.entity instanceof Post) {
        return this.entity.image_url;
      }
      else if (this.entity instanceof AdCopyMagicItem) {
        return this.entity.image?.url;
      }
      else if (this.entity instanceof ContentGenerationItem) {
        return this.entity.image?.url;
      }

      return null;
    },
    computedText() {
      if (this.text) {
        return this.text;
      }

      if (this.entity instanceof Ad) {
        return this.entity.text ?? this.entity.name;
      }
      else if (this.entity instanceof Post) {
        return this.entity.text;
      }
      else if (this.entity instanceof AdCopyMagicItem) {
        return this.entity.text;
      }
      else if (this.entity instanceof ContentGenerationItem) {
        return this.entity.content;
      }

      return null;
    },
  },
};
</script>
